var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.grades),function(grade){return _c('SingleGradeSquare',{key:grade.key,attrs:{"grade":grade,"isSek2":_vm.isSek2}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }